import LoadingBar, { LoadingBarRef } from 'react-top-loading-bar';
import { useEffect, useRef } from 'react';
import { useTheme } from '@mui/material';
import { useIsFetching } from 'react-query';

const TopLoadingBar = () => {
  const isFetching = useIsFetching();
  const theme = useTheme();
  const ref = useRef<LoadingBarRef>(null);

  useEffect(() => {
    if (isFetching) {
      ref.current?.continuousStart(0, 1);
    } else {
      ref.current?.complete();
    }
  }, [isFetching]);

  return <LoadingBar ref={ref} color={theme.palette.primary.main} />;
};

export default TopLoadingBar;
